export class NewParticipantRes {
   
    inclusionList:Array<any>;exclusionList:Array<any> =[ 
        { "title": String }]
    
  }